import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export const date = (
  dateString: string,
  options = { format: "dd/MM/yyyy" }
) => {
  return format(new Date(dateString), options.format, {
    locale: ptBR,
  });
};

export const dateTime = (
  dateString: string,
  options = { format: 'dd/MM/yyyy HH:mm' }
) => {
  return format(new Date(dateString), options.format, {
    locale: ptBR,
  });
};


export const onlyDate = (
  dateString: string,
  options = { format: "dd/MM/yyyy" }
) => {
  return format(new Date(`${dateString} 00:00:00`), options.format, {
    locale: ptBR,
  });
};

export const dayOfWeek = (dateString: string, options = { format: "EEEE" }) => {
  return format(new Date(dateString), options.format, {
    locale: ptBR,
  });
};

export const secondsToHours = (second: number) => {
  const hours = second / 3600;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);

  return `${rhours.toString().padStart(2, "0")}:${rminutes
    .toString()
    .padStart(2, "0")}`;
};


export const expirationDaysText = (days_left_password: number) => {
  const suffixDays = days_left_password > 1 ? "dias" : "dia";

  return `Sua senha expira em ${days_left_password} ${suffixDays}.`;
}

export const nativeDate = (dateString: string | number, locale?: string, showHours = false): string => {
  let idiom = "";

  if(dateString === "0000-00-00 00:00:00") {
    return '----'
  }

  switch (locale) {
    case 'en':
      idiom = "en-US";
    break;
    case 'du':
      idiom = "de-DE";
    break;
    case 'es':
      idiom = "es-ES";
    break;
    default:
      idiom = "pt-BR";
  }

  const optionsHours: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric', month: 'numeric', day: 'numeric',
    timeZone: 'America/Sao_Paulo'
  }

  return new Intl.DateTimeFormat(
    idiom,
    showHours ? { ...options, ...optionsHours } : options
  ).format(new Date(dateString));
}

export const nativeISOZone = (date: string | null): string | undefined => {
  if(!date) return undefined;
  
  const oldDate = new Date(date);

  const d2 = new Date(oldDate.valueOf() - oldDate.getTimezoneOffset() * 60000)

  return d2.toISOString().substring(0, 19)
}

export const dateInput = (
  dateString: string,
  options = { format: "yyy-MM-dd'" }
) => {
  return format(new Date(dateString), options.format);
};